import React from 'react';
import { Box, Container, makeStyles, Typography } from '@material-ui/core';
import Page from 'src/app/components/Page';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
}));

const NotFoundView = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Trang lỗi">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="md">
          <Typography align="center" color="textPrimary" variant="h1">
            404: Trang không xác định
          </Typography>
          <Typography align="center" color="textPrimary" variant="subtitle2">
            Trang mà bạn đang cố gắng truy cập không có sẵn hoặc nằm ngoài quyền
            hạn của bạn
          </Typography>
          <Box textAlign="center">
            <img
              alt="Under development"
              className={classes.image}
              src="/static/images/not_found.png"
            />
          </Box>
        </Container>
      </Box>
    </Page>
  );
};

export default NotFoundView;
